module.exports = __webpack_public_path__ + "media/复杂声音事件介绍视频0624（2）.bc5e11c8.mp4";